import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';
import { ErrorMessage, Field } from 'formik';

export default function SwitchField({
  id, name, uncheckedLabel, checkedLabel, required,
}) {
  return (
    <Form.Group className="mb-3 p-0 form-check form-switch d-flex align-items-center" controlId={id}>
      {uncheckedLabel && (
        <Form.Label className="form-check-label m-0 me-2">
          {uncheckedLabel}
        </Form.Label>
      )}

      <Field
        type="checkbox"
        role="switch"
        id={id}
        name={name}
        className="form-check-input switch-boolean m-0"
      />

      <Form.Label className="form-check-label m-0 ms-2">
        <>
          {checkedLabel}
          {required && <abbr className="ms-1" title="required">*</abbr>}
        </>
      </Form.Label>

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

SwitchField.propTypes = {
  id: PropTypes.string.isRequired,
  uncheckedLabel: PropTypes.string,
  checkedLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

SwitchField.defaultProps = {
  uncheckedLabel: '',
  required: false,
};
